<template>
  <div>
    <el-card class="left-box">
      <el-card class="topInfo">
        <div class="wh100 df">
          <!-- //项目信息 -->
          <el-card style="width: 25%; height: 100%" shadow="never">
            <div
              class="cellInfo"
              @click="toDomRouter('info')"
              v-loading="ProjectLoading"
            >
              <div class="cellInfo-title">
                <div
                  style="width: calc(100% - 80px); color: #606266"
                  class="ellipsis"
                >
                  项目信息
                </div>
                <div
                  style="width: 80px; display: flex; justify-content: center"
                >
                  <el-tag
                    size="medium"
                    style="text-align: center"
                    v-if="ProjectInfo.ProjectStatus == 0"
                    >新建</el-tag
                  >
                  <el-tag
                    type="warning"
                    size="medium"
                    style="text-align: center"
                    v-if="ProjectInfo.ProjectStatus == 1"
                    >进行中</el-tag
                  >

                  <el-tag
                    type="success"
                    size="medium"
                    style="text-align: center"
                    v-if="ProjectInfo.ProjectStatus == 2"
                    >完成</el-tag
                  >
                </div>
              </div>
              <div class="df">
                <el-image
                  :src="ProjectInfo.ProjectImg"
                  fit="cover"
                  style="width: 140px; height: 140px; border-radius: 20px"
                ></el-image>
                <div class="cellInfo-content">
                  <div
                    style="width: 100%"
                    class="projectText ellipsis"
                    :title="ProjectInfo.Name"
                  >
                    {{ ProjectInfo.Name }}
                  </div>
                  <div
                    style="width: 100%"
                    class="projectText ellipsis"
                    :title="ProjectInfo.Code"
                  >
                    项目编号：{{ ProjectInfo.Code }}
                  </div>
                  <div
                    style="width: 100%"
                    class="projectText ellipsis"
                    :title="ProjectInfo.TotalArea"
                  >
                    建筑面积：{{ ProjectInfo.TotalArea }}
                  </div>
                  <div
                    style="width: 100%"
                    class="projectText ellipsis"
                    :title="ProjectInfo.TotalFloor"
                  >
                    位置：{{ ProjectInfo.Province }} {{ ProjectInfo.City }}
                  </div>
                  <div
                    style="width: 100%"
                    class="projectText ellipsis"
                    :title="
                      ProjectInfo.OpeningTime
                        ? moment(ProjectInfo.OpeningTime).format(
                            'YYYY年MM月DD日'
                          )
                        : ''
                    "
                  >
                    开工：{{
                      ProjectInfo.OpeningTime
                        ? moment(ProjectInfo.OpeningTime).format(
                            'YYYY年MM月DD日'
                          )
                        : ''
                    }}
                  </div>

                  <div
                    style="width: 100%"
                    class="projectText ellipsis"
                    :title="ProjectInfo.ProjectManagerName"
                  >
                    项目经理：{{ ProjectInfo.ProjectManagerName }}
                  </div>
                  <div
                    style="width: 100%"
                    class="projectText ellipsis"
                    :title="ProjectInfo.Property_Company"
                  >
                    物业单位：{{ ProjectInfo.Property_Company }}
                  </div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card style="width: 400px; height: 100%" shadow="never">
            <div class="wh100" style="display: flex">
              <el-card class="ButInfo">
                <div @click="toDomRouter('File')" class="ButInfo-content">
                  <div>
                    <div class="icon">
                      <i class="icon-yunpan icon" style="color: #70babf"></i>
                    </div>
                    <div class="text" style="color: #70babf">项目云盘</div>
                  </div>
                </div>
              </el-card>
              <el-card class="ButInfo">
                <div
                  @click="toDomRouter('ProjectOverview')"
                  class="ButInfo-content"
                >
                  <div>
                    <div class="icon">
                      <i
                        class="icon-analyticsprogram icon"
                        style="color: #67c23a"
                      ></i>
                    </div>
                    <div class="text" style="color: #67c23a">项目统计</div>
                  </div>
                </div>
              </el-card>
            </div>
          </el-card>
          <el-card
            style="width: calc(75% - 400px); height: 100%"
            shadow="never"
          >
            <div class="wh100">
              <div class="Buttop">
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div
                    @click="toDomRouter('ProjectClass')"
                    class="wh100 df aic cup juc"
                    style="padding: 0px 10px; color: rgb(230, 162, 60)"
                  >
                    <i class="icon-shebei icon"></i>
                    <span class="text">1. 项目设备分类</span>
                  </div>
                </el-card>
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div
                    @click="toDomRouter('TempSupplier')"
                    class="wh100 df aic cup juc"
                    style="padding: 0px 10px; color: #bfa170"
                  >
                    <i class="icon-gongyingshang1 icon"></i>
                    <span class="text">2. 邀请供应商</span>
                  </div>
                </el-card>
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div
                    @click="toDomRouter('Facility')"
                    class="wh100 df aic cup juc"
                    style="padding: 0px 10px; color: #409eff"
                  >
                    <i
                      class="el-icon-files"
                      style="font-size: 30px !important"
                    ></i>
                    <span class="text">3. 资料模板</span>
                  </div>
                </el-card>
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div
                    @click="toDomRouter('ProjectInfoHandOver')"
                    class="wh100 df aic cup juc"
                    style="padding: 0px 10px; color: #f56c6c"
                  >
                  <i
                      class="el-icon-s-claim"
                      v-if="ProjectInfo.ProjectStatus == 2"
                      style="color: #67c23a; font-size: 30px !important"
                    ></i>
                    <span
                      class="text"
                      v-if="ProjectInfo.ProjectStatus == 2"
                      style="color: #67c23a"
                      >移交报告</span
                    >
                    <i
                      class="icon-wailaibaoyijiao icon"
                       v-if="ProjectInfo.ProjectStatus != 2"
                    ></i>
                    <span class="text" 
                    v-if="ProjectInfo.ProjectStatus != 2">4. 项目移交</span
                    >
                  </div>
                </el-card>
              </div>
              <div class="Buttop">
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div class="wh100 df aic juc" style="padding: 0px 10px">
                    <div class="leftNum">
                      <div
                        class="ellipsis num w100 tac"
                        :title="`${Math.round(
                          Number(dataStatistics.DeviceSubQty || 0)
                        )}/${Math.round(
                          Number(dataStatistics.DeviceQty || 0)
                        )}`"
                      >
                        <span style="font-size: 18px">{{
                          Math.round(Number(dataStatistics.DeviceSubQty || 0))
                        }}</span
                        >/{{
                          Math.round(Number(dataStatistics.DeviceQty || 0))
                        }}
                      </div>
                      <div class="w100 tac">
                        <span style="font-size: 12px">提交数/总数</span>
                      </div>
                    </div>
                    <div class="rightNum" style="color: #e6a23c">
                      <div class="w100 tac">
                        <i
                          class="icon-shebei icon"
                          style="color: #e6a23c; font-size: 24px"
                        ></i>
                      </div>
                      <div class="w100 tac">设备</div>
                    </div>
                  </div>
                </el-card>
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div class="wh100 df aic juc" style="padding: 0px 10px">
                    <div class="leftNum">
                      <div
                        class="ellipsis num w100 tac"
                        :title="`${Math.round(
                          Number(dataStatistics.SupplierSubQty || 0)
                        )}/${Math.round(
                          Number(dataStatistics.SupplierQty || 0)
                        )}`"
                      >
                        <span style="font-size: 18px">{{
                          Math.round(Number(dataStatistics.SupplierSubQty || 0))
                        }}</span
                        >/{{
                          Math.round(Number(dataStatistics.SupplierQty || 0))
                        }}
                      </div>
                      <div class="w100 tac">
                        <span style="font-size: 12px">提交数/总数</span>
                      </div>
                    </div>
                    <div class="rightNum" style="color: #bfa170">
                      <div class="w100 tac">
                        <i
                          class="icon-gongyingshang1 icon"
                          style="font-size: 24px"
                        ></i>
                      </div>
                      <div class="w100 tac">供应商</div>
                    </div>
                  </div>
                </el-card>
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div class="wh100 df aic juc" style="padding: 0px 10px">
                    <div class="leftNum">
                      <div
                        class="ellipsis num w100 tac"
                        :title="`${Math.round(
                          Number(dataStatistics.DataSubData || 0)
                        )}/${Math.round(Number(dataStatistics.DataQty || 0))}`"
                      >
                        <span style="font-size: 18px">{{
                          Math.round(Number(dataStatistics.DataSubData || 0))
                        }}</span
                        >/{{ Math.round(Number(dataStatistics.DataQty || 0)) }}
                      </div>
                      <div class="w100 tac">
                        <span style="font-size: 12px">提交数/总数</span>
                      </div>
                    </div>
                    <div class="rightNum" style="color: #409eff">
                      <div class="w100 tac">
                        <i class="el-icon-tickets" style="font-size: 24px"></i>
                      </div>
                      <div class="w100 tac">资料</div>
                    </div>
                  </div>
                </el-card>
                <el-card style="width: 25%; height: 100%" shadow="never">
                  <div class="wh100 df aic juc" style="padding: 0px 10px">
                    <div class="leftNum">
                      <div
                        class="ellipsis num w100 tac"
                        :title="`${Math.round(
                          Number(dataStatistics.SparePartsSubQty || 0)
                        )}/${Math.round(
                          Number(dataStatistics.SparePartsQty || 0)
                        )}`"
                      >
                        <span style="font-size: 18px">{{
                          Math.round(
                            Number(dataStatistics.SparePartsSubQty || 0)
                          )
                        }}</span
                        >/{{
                          Math.round(Number(dataStatistics.SparePartsQty || 0))
                        }}
                      </div>
                      <div class="w100 tac">
                        <span style="font-size: 12px">提交数/总数</span>
                      </div>
                    </div>
                    <div class="rightNum" style="color: #6bc1c1">
                      <div class="w100 tac">
                        <i class="el-icon-menu" style="font-size: 24px"></i>
                      </div>
                      <div class="w100 tac">配件</div>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </el-card>
        </div>
      </el-card>

      <!-- 待办列表 待审核 已通过 已驳回 -->
      <el-card
        v-loading="loading1"
        style="
          height: calc(100% - 310px);
          width: 100%;
          margin-top: 10px;
          padding: 0px 10px;
        "
      >
        <el-tabs
          v-model="tabswait"
          style="height: 100%"
          @tab-click="changeTableData"
        >
          <el-tab-pane label="已审核" name="tg" v-loading="loading2">
            <el-table
              ref="passTable"
              :data="passData"
              height="calc(100% - 40px)"
              @row-click="handleClick"
            >
              <el-table-column
                type="index"
                label="序号"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                label="设备编号"
                prop="device_no"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备名称"
                prop="device_name"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备规格"
                prop="specification"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备数量"
                prop="Num"
                align="right"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="安装日期"
                prop="purchase_date"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="填写人"
                prop="cVenName"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="生产厂家名称"
                prop="manufacturer"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="维修商名称"
                prop="maintenance"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- <el-table-column
                label="提交人"
                prop="SubmitUserName"
                align="center"
                sortable
              >
              </el-table-column> -->
              <el-table-column
                label="提交日期"
                prop="SubmitTime"
                width="130"
                align="center"
                show-overflow-tooltip
                sortable
              >
                <template slot-scope="scope">
                  {{ moment(scope.row.SubmitTime).format('YYYY-MM-DD') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="Status"
                label="状态"
                align="center"
                width="130"
                sortable
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.Status == 1" type="warning"
                    >{{
                      scope.row.Reviewer?.length == 1 ? '部分审核' : '待审核'
                    }}
                  </el-tag>
                  <el-tag
                    v-if="scope.row.Status == 2 || scope.row.Status == 3"
                    type="success"
                    >已审核
                  </el-tag>
                  <el-tag v-if="scope.row.Status == 4" type="danger"
                    >驳回
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="审核人"
                prop="Reviewer"
                width="130"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-for="item in scope.row.Reviewer" :key="item">{{
                    item
                  }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: right;
              "
            >
              <el-pagination
                @size-change="passhandleSizeChange"
                @current-change="passhandleCurrentChange"
                :current-page="passpagination.PageIndex"
                :page-sizes="passpagination.PageSizes"
                :page-size="passpagination.PageRows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="passpagination.total"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="待审核列表" name="wait" v-loading="loading1">
            <el-table
              ref="waitTable"
              :data="tableData"
              height="calc(100% - 40px)"
              @row-click="handleClick"
            >
              <el-table-column
                type="index"
                label="序号"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                label="设备编号"
                prop="device_no"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备名称"
                prop="device_name"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备规格"
                prop="specification"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备数量"
                prop="Num"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="安装日期"
                prop="purchase_date"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="填写人"
                prop="cVenName"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="生产厂家名称"
                prop="manufacturer"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="维修商名称"
                prop="maintenance"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- <el-table-column
                label="提交人"
                prop="SubmitUserName"
                align="center"
                sortable
              >
              </el-table-column> -->
              <el-table-column
                label="提交日期"
                prop="SubmitTime"
                width="130"
                align="center"
                show-overflow-tooltip
                sortable
              >
                <template slot-scope="scope">
                  {{ moment(scope.row.SubmitTime).format('YYYY-MM-DD') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="Status"
                label="状态"
                align="center"
                width="130"
                sortable
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.Status == 1" type="warning"
                    >{{
                      scope.row.Reviewer?.length == 1 ? '部分审核' : '待审核'
                    }}
                  </el-tag>
                  <el-tag
                    v-if="scope.row.Status == 2 || scope.row.Status == 3"
                    type="success"
                    >已审核
                  </el-tag>
                  <el-tag v-if="scope.row.Status == 4" type="danger"
                    >驳回
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="审核人"
                prop="Reviewer"
                width="130"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-for="item in scope.row.Reviewer" :key="item">{{
                    item
                  }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: right;
              "
            >
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.PageIndex"
                :page-sizes="pagination.PageSizes"
                :page-size="pagination.PageRows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已驳回" name="bh" v-loading="loading3">
            <el-table
              ref="rejectTable"
              :data="rejectData"
              height="calc(100% - 40px)"
              @row-click="handleClick"
            >
              <el-table-column
                type="index"
                label="序号"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                label="设备编号"
                prop="device_no"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备名称"
                prop="device_name"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备规格"
                prop="specification"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备数量"
                prop="Num"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="安装日期"
                prop="purchase_date"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="填写人"
                prop="cVenName"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="生产厂家名称"
                prop="manufacturer"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="维修商名称"
                prop="maintenance"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- <el-table-column
                label="提交人"
                prop="SubmitUserName"
                align="center"
                sortable
              >
              </el-table-column> -->
              <el-table-column
                label="提交日期"
                prop="SubmitTime"
                width="130"
                align="center"
                sortable
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ moment(scope.row.SubmitTime).format('YYYY-MM-DD') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="Status"
                label="状态"
                align="center"
                width="130"
                sortable
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.Status == 1" type="warning"
                    >{{
                      scope.row.Reviewer?.length == 1 ? '部分审核' : '待审核'
                    }}
                  </el-tag>
                  <el-tag
                    v-if="scope.row.Status == 2 || scope.row.Status == 3"
                    type="success"
                    >已审核
                  </el-tag>
                  <el-tag v-if="scope.row.Status == 4" type="danger"
                    >驳回
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="审核人"
                prop="Reviewer"
                width="130"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-for="item in scope.row.Reviewer" :key="item">{{
                    item
                  }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: right;
              "
            >
              <el-pagination
                @size-change="rejecthandleSizeChange"
                @current-change="rejecthandleCurrentChange"
                :current-page="rejectpagination.PageIndex"
                :page-sizes="rejectpagination.PageSizes"
                :page-size="rejectpagination.PageRows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="rejectpagination.total"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
      <!-- 统计  -->
      <el-card
        style="
          width: 100%;
          height: 300px;
          margin-top: 10px;
          box-sizing: border-box;
          padding: 0px 10px;
        "
      >
        <el-tabs v-model="tabsStatistics" style="height: 100%">
          <el-tab-pane
            label="工作统计"
            name="Statistics"
            v-loading="ProjectCountLoading"
            style="height: 100%"
          >
            <div
              style="
                width: 100%;
                height: calc(100% - 10px);
                box-sizing: border-box;
              "
            >
              <el-row style="width: 100%; height: 100%" :gutter="20">
                <el-col :span="4" style="height: 100%">
                  <el-card
                    style="
                      width: 100%;
                      height: 100%;
                      position: relative;
                      padding: 0px 10px;
                    "
                    :body-style="{
                      padding: 0,
                    }"
                  >
                    <div
                      style="width: 100%; height: calc(100%); margin-top: 60px"
                      id="DeviceProgress"
                    ></div>
                    <div
                      style="
                        height: 30px;
                        width: 100%;
                        position: absolute;
                        top: 20px;
                        left: 0;
                        text-align: center;
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 30px;
                      "
                    >
                      提交率<span class="hint-text">(乙供+甲供)</span>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="4" style="height: 100%">
                  <el-card
                    style="
                      width: 100%;
                      height: 100%;
                      position: relative;
                      padding: 0px 10px;
                    "
                    :body-style="{
                      padding: 0,
                    }"
                  >
                    <div
                      style="width: 100%; height: calc(100%); margin-top: 60px"
                      id="DocumentProgress"
                    ></div>
                    <div
                      style="
                        height: 30px;
                        width: 100%;
                        position: absolute;
                        top: 20px;
                        left: 0;
                        text-align: center;
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 30px;
                      "
                    >
                      通过率<span class="hint-text">(乙供+甲供)</span>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="16" style="height: 100%">
                  <el-card
                    style="
                      width: 100%;
                      height: 100%;
                      position: relative;
                      padding: 0px 10px;
                    "
                    :body-style="{
                      padding: 0,
                    }"
                  >
                    <div
                      style="width: 100%; height: calc(100%)"
                      id="DocumentBar"
                    ></div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <div
        :style="{
          height: supplierBarHeight + 'px',
          width: '100%',
          'margin-top': '10px',
        }"
      >
        <el-card
          style="height: 100%; width: 100%; position: relative; padding: 10px"
          v-loading="SupplierCountLoading"
        >
          <div
            style="
              height: 30px;

              position: absolute;
              top: 20px;
              left: 20px;
              text-align: center;
              font-weight: bold;
              font-size: 18px;
              line-height: 30px;
            "
          >
            供应商提交率/通过率<span class="hint-text">(乙供+甲供)</span>
          </div>
          <div style="width: 100%; height: calc(100%)" id="SupplierBar"></div>
        </el-card>
      </div>
    </el-card>
    <ScheduleView
      ref="ScheduleView"
      @refresh="
        () => {
          this.getTableData(1)
          this.getTableData(2)
          this.getTableData(4)
        }
      "
    ></ScheduleView>
  </div>
</template>
<script>
import moment from 'moment'
import ScheduleView from '@/views/Project/Page/ProjectAudit/ScheduleView.vue'
import * as echarts from 'echarts'
export default {
  data() {
    return {
      echarts,
      tabswait: 'tg',
      tabsStatistics: 'Statistics',
      //供应商进度
      ProjetSupSubmissionRateList: [],
      //设备进度
      ProjetDeviceTypeSubmissionRateList: [],
      moment,
      dataStatistics: {},
      dataStatisticsList: [],
      loading1: false,
      loading2: false,
      loading3: false,

      pId: '',
      ProjectInfo: {},
      domList: [
        {
          name: 'info',
          label: '项目信息',
          labelColor: '#409EFF',
          icon: 'el-icon-notebook-2',
          IconColor: '#409EFF',

          path: 'Info',
        },
        {
          name: 'Facility',
          label: '设备分类',
          labelColor: '#C06BC1',
          icon: 'icon-shebei',
          IconColor: '#C06BC1',
          path: 'Facility',
        },
        {
          name: 'TempSupplier',
          label: '项目供应商',
          IconColor: '#BFA170',
          icon: 'icon-gongyingshang1',
          labelColor: '#BFA170',
          path: 'TempSupplier',
        },
        {
          name: 'File',
          label: '项目文档',

          icon: 'el-icon-folder',
          labelColor: '#70BABF',
          IconColor: '#70BABF',
          path: 'File',
        },
        // {
        //   name: 'ProjectStatistic',
        //   label: '统计信息',
        //   icon: 'el-icon-s-order',
        //   labelColor: '#67C23A',
        //   IconColor: '#67C23A',
        //   path: 'ProjectStatistic',
        // },
        {
          name: 'ProjectOverview',
          label: '项目统计总览',
          icon: 'el-icon-s-order',
          labelColor: '#67C23A',
          IconColor: '#67C23A',
          path: 'ProjectOverview',
        },
        // {
        //   name: "DeviceStatistic",
        //   label: "设备统计信息",

        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "DeviceStatistic",
        // },
        // {
        //   name: "SupplierStatistic",
        //   label: "供应商统计信息",
        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "SupplierStatistic",
        // },

        {
          name: 'BimModel',
          label: 'BIM模型',
          icon: 'el-icon-office-building',
          labelColor: '#DCDFE6',
          IconColor: '#DCDFE6',
          path: 'BimModel',
        },
        // {
        //   name: "Spare",
        //   label: "配件清单",

        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "Spare",
        // },
        // {
        //   name: "ScheduleDocument",
        //   label: "设备资料清单",
        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "ScheduleDocument",
        // },
        // {
        //   name: "Schedule",
        //   label: "设备审核",
        //   icon: "el-icon-edit-outline",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        //   path: "Schedule",
        // },
        // {
        //   name: "ProjectDocument",
        //   label: "项目资料审核",
        //   icon: "el-icon-edit-outline",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        //   path: "ProjectDocument",
        // },
        // {
        //   name: "TeamAuditDocument",
        //   label: "供应商审核",
        //   icon: "el-icon-edit-outline",
        //   path: "TeamAuditDocument",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        // },
        // {
        //   name: "ProjectInspect",
        //   label: "项目完结检查",
        //   icon: "icon-wailaibaoyijiao icon",
        //   labelColor: "#F56C6C",
        //   IconColor: "#F56C6C",
        //   path: "ProjectInspect",
        // },
      ],
      ProjectInspect: {
        name: 'ProjectInspect',
        label: '项目完结',
        icon: 'icon-wailaibaoyijiao icon',
        labelColor: '#F56C6C',
        IconColor: '#F56C6C',
        path: 'ProjectInspect',
      },
      TitleData: [],
      //待办列表
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 30, 50, 100],
        total: 0,
      },
      //通过列表
      passData: [],
      passpagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 30, 50, 100],
        total: 0,
      },
      //驳回列表
      rejectData: [],
      rejectpagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 30, 50, 100],
        total: 0,
      },
      ProjectLoading: false,
      StatisticsLoading: false,
      ProjectCountLoading: false,
      ProjectCount: {},
      SupplierCount: [],
      SupplierCountLoading: false,
      supplierBarHeight: 600, // 默认高度
      supplierChart: null, // 存储图表实例
      resizeListener: null, // 存储resize监听器
    }
  },
  props: {
    // pId: {
    //   type: String,
    //   default: "",
    // },
  },
  components: { ScheduleView },
  methods: {
    changeTableData() {
      console.log(this.tabswait)
      if (this.tabswait === 'wait') {
        this.pagination.PageIndex = 1
        this.getTableData(1)
      } else if (this.tabswait === 'tg') {
        this.passpagination.PageIndex = 1
        this.getTableData(2)
      } else if (this.tabswait === 'bh') {
        this.rejectpagination.PageIndex = 1
        this.getTableData(4)
      }
    },
    handleClick(row) {
      this.$refs.ScheduleView.openDrawer(row)
    },
    getTableData(num) {
      let str = ''
      let data = ''
      if (num == 1) {
        str = 'pagination'
        data = 'tableData'
        this.loading1 = true
      } else if (num == 2 || num == 3) {
        this.loading2 = true
        str = 'passpagination'
        data = 'passData'
      } else if (num == 4) {
        this.loading3 = true
        str = 'rejectpagination'
        data = 'rejectData'
      }
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjectDeviceList',
          {
            ProjectId: this.pId,
            // DeviceType: this.TreeId,
            // Keyword: this.searchValue,
            PageIndex: this[str].PageIndex,
            PageRows: this[str].PageRows,
            State: num,
          }
          // {

          //   PageIndex: this.pagination.PageIndex,
          //   PageRows: this.pagination.PageRows,
          //   SortField: "Id",
          //   SortType: "asc",
          //   Search: [
          //     {
          //       Condition: "DeviceType",
          //       Keyword: this.TreeId,
          //     },
          //     {
          //       Condition: "cVenName",
          //       Keyword: this.searchValue,
          //     },
          //   ],
          // }
        )
        .then((res) => {
          if (num == 1) {
            this.loading1 = false
          } else if (num == 2 || num == 3) {
            this.loading2 = false
          } else if (num == 4) {
            this.loading3 = false
          }

          if (res.Success) {
            this[data] = res.Data.TableData
            this.TitleData = res.Data.TitleData
            this[str].total = res.Data.Total
            // 解决tab切换后表格高度异常问题
            this.$nextTick(() => {
              // 延迟执行，确保 DOM 更新完成
              setTimeout(() => {
                // 根据当前激活tab重新计算表格布局
                if (this.tabswait === 'wait' && this.$refs.waitTable) {
                  this.$refs.waitTable.doLayout()
                } else if (this.tabswait === 'tg' && this.$refs.passTable) {
                  this.$refs.passTable.doLayout()
                } else if (this.tabswait === 'bh' && this.$refs.rejectTable) {
                  this.$refs.rejectTable.doLayout()
                }
              }, 100)
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    GetProjetSupSubmissionRateList() {
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjetSupSubmissionRate?ProjectId=' +
            this.pId,
          {}
        )
        .then((res) => {
          if (res.Success) {
            this.ProjetSupSubmissionRateList = res.Data
          }
        })
    },
    GetProjetDeviceTypeSubmissionRateList() {
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjetDeviceTypeSubmissionRate?ProjectId=' +
            this.pId,
          {}
        )
        .then((res) => {
          if (res.Success) {
            this.ProjetDeviceTypeSubmissionRateList = res.Data
          }
        })
    },
    toDomRouter(path) {
      if (path === 'ProjectInfoHandOver') {
        if (this.ProjectInfo.ProjectStatus == 0) {
          return this.$notify.warning('当前项目未开始')
        }
      }
      this.$router.push({
        path: `/ProjectInfo/${path}?id=${this.pId}&name=${this.ProjectInfo.Name}`,
      })
    },
    toDom(name) {
      this.$emit('toDom', name)
    },
    exportData() {},
    getDataList() {
      this.StatisticsLoading = true
      this.$http
        .post(`/Base_ProjectWork/Base_Project/GetProjectStatistic`, {
          // PageIndex: this.pagination.PageIndex,
          // PageRows: this.pagination.PageRows,
          Search: {
            ProjectId: this.pId,
          },
        })
        .then((res) => {
          this.StatisticsLoading = false
          if (res.Success) {
            this.dataStatistics = res.Data.dataStatistics
            this.dataStatisticsList = res.Data.dataStatisticsList
          } else {
            this.$notify.error(res.Message)
          }
        })
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getTableData(1)
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getTableData(1)
    },
    passhandleCurrentChange(PageIndex) {
      this.passpagination.PageIndex = PageIndex
      this.getTableData(2)
    },
    passhandleSizeChange(PageRows) {
      this.passpagination.PageIndex = 1
      this.passpagination.PageRows = PageRows
      this.getTableData(2)
    },
    rejecthandleCurrentChange(PageIndex) {
      this.rejectpagination.PageIndex = PageIndex
      this.getTableData(4)
    },
    rejecthandleSizeChange(PageRows) {
      this.rejectpagination.PageIndex = 1
      this.rejectpagination.PageRows = PageRows
      this.getTableData(4)
    },
    async getProjectInfo(id) {
      this.ProjectLoading = true
      await this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', { id })
        .then((res) => {
          this.ProjectLoading = false
          if (res.Success) {
            this.ProjectInfo = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getProjectCount() {
      this.ProjectCountLoading = true
      this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectCount?ProjectId=${this.pId}`,
          {}
        )
        .then((res) => {
          this.ProjectCountLoading = false
          if (res.Success) {
            this.ProjectCount = res.Data
            this.$nextTick(() => {
              for (let index = 0; index < 2; index++) {
                var chartDom = document.getElementById(
                  index == 0 ? 'DeviceProgress' : 'DocumentProgress'
                )
                var myChart = echarts.init(chartDom)
                var option
                option = {
                  tooltip: {
                    appendToBody: true,
                    formatter: '{a} : {c}%',
                  },
                  series: [
                    {
                      name: index == 0 ? '提交率' : '通过率',
                      type: 'gauge',
                      startAngle: 180,
                      endAngle: 360,
                      min: 0,
                      max: 100,
                      splitNumber: 10,
                      radius: '100%',
                      progress: {
                        show: true,
                        width: 10, //进度条宽度
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },

                        roundCap: true,
                      },
                      // 外层轴线
                      axisLine: {
                        lineStyle: {
                          width: 10,
                        },
                      },
                      axisTick: {
                        //刻度线
                        show: true,
                        distance: 6,
                        length: 7,
                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      splitLine: {
                        //表盘内刻度文字上刻度线
                        distance: 10,
                        show: true, // 显示分割线
                        length: 8, // 分割线长度，可以根据需要调整

                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      axisLabel: {
                        //表盘内刻度文字
                        distance: 10,
                        color: '#999',
                        fontSize: 8,
                      },
                      // center: ["50%", "50%"],
                      // radius: "90%",
                      pointer: {
                        width: 2, // 指针宽度，可以根据需要调整
                        length: '70%', // 指针长度，可以根据需要调整为百分比或具体数值
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },
                      },
                      detail: {
                        formatter: '{value}%',
                        textStyle: {
                          fontSize: 12,
                          color: '#333',
                        },

                        offsetCenter: [0, 10], // 详细指标位置，可以根据需要调整
                      },

                      data: [
                        {
                          value:
                            index == 0
                              ? this.ProjectCount.SubmissionRate || 0
                              : this.ProjectCount.PassingRate || 0,
                          // name: index == 0 ? "设备提交率" : "文档通过率",
                        },
                      ],
                    },
                  ],
                }
                option && myChart.setOption(option)
              }
              var barDom = document.getElementById('DocumentBar')
              var barChart = echarts.init(barDom)
              var baroption
              baroption = {
                title: {
                  text: '设备分类提交率/通过率',
                  left: 'left',
                  top: 10,
                },
                legend: {
                  data: [],
                  top: 10,
                },
                grid: {
                  top: 60,
                  left: 60,
                  bottom: 40,
                  right: 40,
                },
                tooltip: {
                  appendToBody: true,
                  trigger: 'item',
                  formatter: '{b} <br/>{a} : {c}%',
                },
                label: {
                  show: true,
                  position: 'top',
                  formatter: `{c}%`,
                },
                xAxis: {
                  type: 'category',
                  axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    show: true,
                    interval: 0,
                  },
                  data: [],
                },
                yAxis: {
                  min: 0,
                  max: 100,
                  axisLabel: {
                    formatter: '{value} %',
                  },

                  show: true,
                  type: 'value',
                  axisLine: {
                    //坐标轴轴线
                    show: true,
                  },
                  axisTick: {
                    //坐标轴刻度
                    show: true,
                  },
                },

                series: [],
              }
              this.ProjectCount.List?.forEach((item, index) => {
                if (index == 0) {
                  item.value.forEach((val) => {
                    baroption.xAxis.data.push(val.name)
                  })
                }
                baroption.legend.data.push(item.name)
                baroption.series.push({
                  name: item.name,
                  type: 'bar',
                  showBackground: true,
                  barGap: '60%',
                  itemStyle: {
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                    shadowBlur: 10,
                    color: index == 0 ? '#409EFF' : '#67C23A',
                  },
                  // color: {
                  //   type: "linear",
                  //   x: 0,
                  //   y: 1,
                  //   x2: 0,
                  //   y2: 0,
                  //   colorStops: [
                  //     {
                  //       offset: 0,
                  //       color: "#409EFF", // 0% 处的颜色
                  //     },
                  //     {
                  //       offset: 0.5,
                  //       color: "yellow", // 100% 处的颜色
                  //     },
                  //     {
                  //       offset: 1,
                  //       color: "#fff", // 100% 处的颜色
                  //     },
                  //   ],
                  // },

                  data: [...item.value],
                })
              })
              baroption && barChart.setOption(baroption)
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getSupplierCount() {
      this.SupplierCountLoading = true
      this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectSupplierSubmissionData?ProjectId=${this.pId}`,
          {}
        )
        .then((res) => {
          this.SupplierCountLoading = false
          if (res.Success) {
            this.SupplierCount = res.Data

            // 根据供应商数量动态计算高度
            let supplierCount = 0
            if (this.SupplierCount && this.SupplierCount.length > 0) {
              supplierCount = this.SupplierCount[0]?.value?.length || 0
            }

            // 动态计算图表容器高度: 基础高度200px + 每个供应商80px
            // 最小高度400px，无最大高度限制
            this.supplierBarHeight = Math.max(400, 200 + supplierCount * 80)

            // 使用多重 nextTick 确保 DOM 完全更新
            this.$nextTick(() => {
              this.$nextTick(() => {
                // 延迟一小段时间确保容器高度已经应用
                setTimeout(() => {
                  this.initSupplierChart(supplierCount)
                }, 100)
              })
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    initSupplierChart(supplierCount) {
      const barDom = document.getElementById('SupplierBar')
      if (!barDom) {
        console.warn('SupplierBar DOM element not found')
        return
      }

      // 销毁已存在的图表实例
      if (this.supplierChart) {
        this.supplierChart.dispose()
      }

      // 确保容器有正确的高度
      barDom.style.height = this.supplierBarHeight + 'px'

      this.supplierChart = echarts.init(barDom)

      // 根据供应商数量调整grid配置
      const gridBottom = supplierCount > 10 ? 80 : 50

      const baroption = {
        // title: {
        //   text: '供应商提交率/通过率',
        //   left: 'left',
        //   top: 10,
        // },
        legend: {
          data: [],
          top: 20,
        },
        grid: {
          top: 80,
          left: 150,
          bottom: gridBottom,
          right: 80,
        },
        tooltip: {
          appendToBody: true,
          trigger: 'item',
          formatter: '{b} <br/>{a} : {c}%',
        },
        label: {
          show: true,
          position: 'right',
          formatter: `{c}%`,
        },
        xAxis: {
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value} %',
          },
          show: true,
          type: 'value',
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            show: true,
            interval: 0,
            lineHeight: 16,
            width: 100,
            overflow: 'break',
          },
          data: [],
        },
        series: [],
      }

      this.SupplierCount.forEach((item, index) => {
        if (index == 0) {
          item.value.forEach((val) => {
            baroption.yAxis.data.push(val.name)
          })
        }
        baroption.legend.data.push(item.name)
        baroption.series.push({
          name: item.name,
          type: 'bar',
          showBackground: true,
          barGap: '30%',
          itemStyle: {
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            shadowBlur: 5,
            color: index == 0 ? '#409EFF' : '#67C23A',
          },
          data: [...item.value],
        })
      })

      this.supplierChart.setOption(baroption)

      // 强制 resize 确保图表占满容器
      setTimeout(() => {
        this.supplierChart.resize()
      }, 50)

      // 监听窗口大小变化，重新调整图表大小
      if (!this.resizeListener) {
        this.resizeListener = () => {
          if (this.supplierChart) {
            this.supplierChart.resize()
          }
        }
        window.addEventListener('resize', this.resizeListener)
      }
    },
  },
  mounted() {},
  async created() {
    this.pId = this.$route.query.id
    this.getProjectInfo(this.$route.query.id)

    this.getDataList()
    //已审核
    this.getTableData(2)

    this.getProjectCount()
    this.getSupplierCount()
    // this.GetProjetDeviceTypeSubmissionRateList();
    // this.GetProjetSupSubmissionRateList();
  },
  computed: {},
  beforeDestroy() {
    // 清理图表实例
    if (this.supplierChart) {
      this.supplierChart.dispose()
      this.supplierChart = null
    }

    // 移除resize监听器
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener)
      this.resizeListener = null
    }
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

::v-deep .left-box .el-card__body {
  padding: 0;
  width: 100%;
  height: 100%;
}

::v-deep .left-box {
  min-width: 1000px;
  height: calc(100vh - 70px);
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  .el-card__header {
    padding: 10px;
    border: none;
  }
  .el-card__body {
    width: 100%;
    height: 100%;
  }
}
.topInfo {
  width: 100%;
  height: 200px;
}
.cellInfo {
  width: 100%;
  height: 100%;
  padding: 0 5px;
  position: relative;
  cursor: pointer;
}
.cellInfo-title {
  height: 40px;
  display: flex;
  font-size: 18px;
  font-weight: bold;
  align-items: center;
}
.cellInfo-content {
  height: 140px;
  width: calc(100% - 140px);
  display: flex;
  align-items: center;
  margin-left: 10px;
  flex-wrap: wrap;
}
.ButInfo {
  width: 50%;
  height: 100%;
  cursor: pointer;
  .ButInfo-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    .icon {
      text-align: center;
      width: 100%;
      i {
        font-size: 70px;
        color: #67c23a;
      }
    }
    .text {
      margin-top: 10px;
      text-align: center;
      width: calc(100%);
      font-size: 16px;
      font-weight: bold;
      color: #67c23a;
    }
  }
}
::v-deep .con .number {
  color: #e6a23c;
}

.head {
  height: 60px;
  margin-bottom: 10px;
  margin-top: 10px;
  // border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
}
.projectText {
  font-size: 12px;
  color: #909399;
}
::v-deep .el-breadcrumb__inner {
  font-weight: 1000 !important;
}
::v-deep .projectCard {
  border: none;
  box-shadow: none;
}
::v-deep .el-tabs__content {
  height: calc(100% - 36px);
  .el-tab-pane {
    height: 100%;
  }
}
::v-deep .el-table__row {
  cursor: pointer;
}
::v-deep .el-card {
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}
::v-deep .el-tabs__header {
  margin-bottom: 5px;
}
.Buttop {
  width: 100%;
  height: 50%;
  display: flex;
  .icon {
    font-size: 30px;
  }
  .text {
    font-size: 16px;
    font-weight: bold;
    margin-left: 5px;
  }
  .leftNum {
    width: calc(100% - 52px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    .num {
      font-size: 22px;
    }
  }
  .rightNum {
    width: 52px;
    flex-wrap: wrap;
  }
}
</style>
